var _defs, _rect, _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoToppay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 112,
    height: 56,
    viewBox: "0 0 112 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5277",
    "data-name": "Rectangle 5277",
    width: 109.014,
    height: 51.112,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54798",
    "data-name": "Path 54798",
    d: "M0,96.713l30.995,25.556L22.712,96.713Z",
    transform: "translate(0 -96.713)",
    fill: "#bfbfbf"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54799",
    "data-name": "Path 54799",
    d: "M0,96.713l30.995,12.778L23.246,96.713Z",
    transform: "translate(0 -96.713)",
    fill: "#5c5c5c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54800",
    "data-name": "Path 54800",
    d: "M30.995,38.335l10.91-9a4.033,4.033,0,0,0-.623-6.646L0,0Z",
    transform: "translate(0 -0.001)",
    fill: "#5c5c5c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5273",
    "data-name": "Rectangle 5273",
    width: 13.171,
    height: 12.778,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54801",
    "data-name": "Path 54801",
    d: "M80.621,109.491,67.45,96.713h2.84Z",
    transform: "translate(-67.45 -96.713)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.872,
    y1: 1.586,
    x2: -0.857,
    y2: 1.586,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afb1b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656668"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5275",
    "data-name": "Rectangle 5275",
    width: 26.853,
    height: 12.778,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54802",
    "data-name": "Path 54802",
    d: "M0,96.713,26.215,107.52l.639,1.971Z",
    transform: "translate(0 -96.713)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.047,
    y1: 1.283,
    x2: 0.056,
    y2: 1.283,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Logo_Toppay",
    transform: "translate(-587 -735)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5216",
    "data-name": "Rectangle 5216",
    width: 112,
    height: 56,
    transform: "translate(587 735)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24778",
    "data-name": "Group 24778",
    transform: "translate(588.631 737.444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24777",
    "data-name": "Group 24777",
    clipPath: "url(#clip-path)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24760",
    "data-name": "Group 24760",
    transform: "translate(0 25.556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24759",
    "data-name": "Group 24759",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5269",
    "data-name": "Rectangle 5269",
    width: 35.452,
    height: 38.403,
    transform: "matrix(0.382, -0.924, 0.924, 0.382, -9.016, 21.833)",
    fill: "#bfbfbf"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_24762",
    "data-name": "Group 24762",
    transform: "translate(0 25.556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24761",
    "data-name": "Group 24761",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5270",
    "data-name": "Rectangle 5270",
    width: 16.293,
    height: 32.27,
    transform: "translate(-1.475 12.605) rotate(-83.327)",
    fill: "#5c5c5c"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_24764",
    "data-name": "Group 24764",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24763",
    "data-name": "Group 24763",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5271",
    "data-name": "Rectangle 5271",
    width: 44.104,
    height: 38.334,
    transform: "translate(0 0)",
    fill: "#5c5c5c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24776",
    "data-name": "Group 24776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24775",
    "data-name": "Group 24775",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24769",
    "data-name": "Group 24769",
    transform: "translate(17.824 25.556)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_24768",
    "data-name": "Group 24768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24767",
    "data-name": "Group 24767",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24766",
    "data-name": "Group 24766",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24765",
    "data-name": "Group 24765",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5272",
    "data-name": "Rectangle 5272",
    width: 17.796,
    height: 17.652,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -5.533, 3.194)",
    fill: "url(#linear-gradient)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24774",
    "data-name": "Group 24774",
    transform: "translate(0 25.556)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_24773",
    "data-name": "Group 24773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24772",
    "data-name": "Group 24772",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24771",
    "data-name": "Group 24771",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24770",
    "data-name": "Group 24770",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5274",
    "data-name": "Rectangle 5274",
    width: 29.645,
    height: 24.493,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -5.533, 3.195)",
    fill: "url(#linear-gradient-2)"
  }))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54803",
    "data-name": "Path 54803",
    d: "M204.221,77.2a2.449,2.449,0,0,0,.505.309l-.15.767q-.1.505-.477.524a1.3,1.3,0,0,1-.842-.356,2.862,2.862,0,0,1-1.169-2.441,3.645,3.645,0,0,1,.066-.571l1.8-9.28a.727.727,0,0,1,.309-.477,1,1,0,0,1,.561-.159h.86L205,69.045h2.189l-.187.935a.764.764,0,0,1-.851.646H204.7l-1.01,5.108a1.721,1.721,0,0,0-.028.318,1.329,1.329,0,0,0,.561,1.151",
    transform: "translate(-148.685 -48.206)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54804",
    "data-name": "Path 54804",
    d: "M227.1,77.625a4.791,4.791,0,0,1,.926.094,3.958,3.958,0,0,1,2.049,1.048,2.757,2.757,0,0,1,.879,2.039,3.14,3.14,0,0,1-.056.58l-.664,3.424a3.394,3.394,0,0,1-1.5,2.227,4.821,4.821,0,0,1-2.778.8,4.931,4.931,0,0,1-.935-.094,3.888,3.888,0,0,1-2.049-1.029,2.768,2.768,0,0,1-.879-2.049,3.084,3.084,0,0,1,.056-.571l.664-3.424a3.423,3.423,0,0,1,1.506-2.245,4.822,4.822,0,0,1,2.778-.8m1.862,2.255a2.317,2.317,0,0,0-1.235-.608,3.7,3.7,0,0,0-2.525.458,1.925,1.925,0,0,0-.833,1.235l-.655,3.414a1.56,1.56,0,0,0-.038.281,1.255,1.255,0,0,0,.421.935,2.339,2.339,0,0,0,1.226.6,3.537,3.537,0,0,0,.636.056,3.3,3.3,0,0,0,1.889-.524,1.887,1.887,0,0,0,.833-1.216l.664-3.424a1.523,1.523,0,0,0,.028-.281,1.26,1.26,0,0,0-.412-.926",
    transform: "translate(-163.408 -57.113)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54805",
    "data-name": "Path 54805",
    d: "M262.076,77.625a4.836,4.836,0,0,1,.935.094,3.869,3.869,0,0,1,2.04,1.019,2.747,2.747,0,0,1,.842,2.638l-.673,3.433a3.428,3.428,0,0,1-1.5,2.236,4.922,4.922,0,0,1-5.519-.1l-.8,4.1h-.982a.644.644,0,0,1-.4-.122.374.374,0,0,1-.131-.384l1.918-9.869a3.423,3.423,0,0,1,1.506-2.245,4.779,4.779,0,0,1,2.769-.8m0,1.581a3.228,3.228,0,0,0-1.88.524,1.925,1.925,0,0,0-.833,1.235l-.608,3.134a1.586,1.586,0,0,0,.318,1.5,2.564,2.564,0,0,0,1.88.655,3.27,3.27,0,0,0,1.88-.514,1.841,1.841,0,0,0,.842-1.226l.664-3.433a1.274,1.274,0,0,0-.552-1.338,2.721,2.721,0,0,0-1.712-.533",
    transform: "translate(-188.259 -57.113)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54806",
    "data-name": "Path 54806",
    d: "M301.636,76.281a5.242,5.242,0,0,1,.973.093,4.141,4.141,0,0,1,2.18,1.085,3.229,3.229,0,0,1,.8,1.3,3.126,3.126,0,0,1,.122,1.637l-.636,3.256a3.727,3.727,0,0,1-1.618,2.423,5.12,5.12,0,0,1-2.591.823,3.862,3.862,0,0,1-2.582-.533l-.7,3.583h-1.328a1,1,0,0,1-.739-.29.8.8,0,0,1-.215-.748l1.815-9.364a3.733,3.733,0,0,1,1.618-2.432,5.036,5.036,0,0,1,2.9-.832m0,2.432a2.615,2.615,0,0,0-1.516.412,1.368,1.368,0,0,0-.6.879l-.58,2.975a1.086,1.086,0,0,0,.168,1,2,2,0,0,0,1.46.487,2.651,2.651,0,0,0,1.525-.4,1.335,1.335,0,0,0,.6-.87l.627-3.246a.8.8,0,0,0-.346-.833,2.133,2.133,0,0,0-1.338-.4",
    transform: "translate(-217.256 -56.124)",
    fill: "#5c5c5c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54807",
    "data-name": "Path 54807",
    d: "M344.131,76.281a4.287,4.287,0,0,1,3.143,1.188,3.111,3.111,0,0,1,.982,2.3,3.414,3.414,0,0,1-.056.627l-.842,4.322a2.863,2.863,0,0,0,.243,1.89H346.33a1.053,1.053,0,0,1-.589-.159.536.536,0,0,1-.253-.309,3.792,3.792,0,0,1-2.423.767,4.346,4.346,0,0,1-3.171-1.207,3.167,3.167,0,0,1-.833-1.347,3.121,3.121,0,0,1-.084-1.571l.636-3.237a3.7,3.7,0,0,1,1.618-2.432,5.009,5.009,0,0,1,2.9-.832m.5,2.488a2.575,2.575,0,0,0-2.02.356,1.339,1.339,0,0,0-.6.879l-.636,3.256a.772.772,0,0,0,.309.795,1.934,1.934,0,0,0,.851.365,2.462,2.462,0,0,0,1.88-.383,1.765,1.765,0,0,0,.8-1.123l.58-2.975a.787.787,0,0,0-.318-.8,1.861,1.861,0,0,0-.851-.365",
    transform: "translate(-249.357 -56.124)",
    fill: "#5c5c5c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54808",
    "data-name": "Path 54808",
    d: "M386.964,77.448l-4.621,10.683a4.629,4.629,0,0,1-1.927,2.245,4.5,4.5,0,0,1-1.216.487,1.4,1.4,0,0,1-1-.056.8.8,0,0,1-.393-.982l.243-1.254a2.4,2.4,0,0,0,1.132-.29,1.741,1.741,0,0,0,.692-.636q-1.16-.215-1.226-2.208l-.253-6.866q-.047-1.123,1.1-1.123h1.3l.262,7.493,2.919-6.735a1.268,1.268,0,0,1,1.291-.758Z",
    transform: "translate(-277.95 -56.982)",
    fill: "#5c5c5c"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoToppay);
export default __webpack_public_path__ + "static/media/Logo_Toppay.9e6fd753f7a726680490ef0e8d75055c.svg";
export { ForwardRef as ReactComponent };